module.exports = __webpack_public_path__ + "media/images/eraf_sunstar_lv_2023-d883151f97b9e56b76265f7f4fd02aa4.svg";